//import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import Tabs from './Tabs'

const container = document.getElementById('tabs-component');
if(null!= container){
    const root = ReactDOM.createRoot(container);
    root.render(<Tabs />);
}
